import script from "./vbatchmanage.vue?vue&type=script&setup=true&lang=js"
export * from "./vbatchmanage.vue?vue&type=script&setup=true&lang=js"

import "./vbatchmanage.vue?vue&type=style&index=0&id=5dee5ff3&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dee5ff3"]])

export default __exports__